import TableCalls from './TableCalls';
import getServiceCalls from '../api/getServiceCalls';
import { InputBase } from '../InputBase';
import { filter, includes } from 'ramda';
import Select, { Option } from './Select';

const ServiceCalls = {
	data: () => ({
		calls: [],
		filter: '',
		loading: false,
		interval: '30',
	}),
	computed: {
		filteredCalls: function() {
			return filter(({ clientPhone }) => includes(this.filter, clientPhone), this.calls)
		},
		intervalMs: function() {
			return this.interval * 1000;
		},
	},
	mounted() {
		const fetchData = async () => {
			clearTimeout(this.$options.timeout);
			this.loading = true;

			const data = await getServiceCalls();

			this.calls = data;
			this.loading = false;
			this.$options.timeout = setTimeout(fetchData, this.intervalMs);

			return data;
		};

		fetchData();

		this.$on('refresh', fetchData);
	},
	destroy() {
		clearTimeout(this.$options.timeout);
	},
	render() {
		return (
			<div>
				<div class="flex items-end">
					<InputBase
						class="mr-auto"
						label="Фильтр по номеру телефона"
						placeholder="Введите цифры номера"
						onInput={ ({ target }) => this.filter = target.value }
						style={{
							width: 'auto',
						}}
					/>
					<Select
						class="input-block__input"
						style={{
							width: 'auto',
						}}
						defaultValue={ this.interval }
						onChange={ ({ target }) => this.interval = target.value }
					>
						<Option value="15">15 сек</Option>
						<Option value="30">30 сек</Option>
						<Option value="60">60 сек</Option>
						<Option value="60">120 сек</Option>
					</Select>
					<button
						class="ml-4 button button_theme_secondary text-nowrap"
						onClick={ () => this.$emit('refresh') }
					>
						Обновить сейчас
					</button>
				</div>
				<TableCalls
					class="mt-4"
					loading={ this.loading }
					dataSource={ this.filteredCalls }
				/>
			</div>
		)
	}
}

export default ServiceCalls;
